console.log('loop', $);
$("button.collapsible-btn").click(function(e) {
    e.preventDefault();
    // 点击合并和打开
    console.log('点击处理', $(this).hasClass("is-open"), $(this).next(".collapsible-content"));
    if ($($(this).next(".collapsible-content")[0]).hasClass("is-open")) {
        // console.log('回调:', $(this).hasClass("is-open"));
        $(this).removeClass("is-open");
        // $(this).remove
        $($(this).next(".collapsible-content")[0]).removeClass("is-open")
        $($(this).next(".collapsible-content")[0]).css({ "height": "0" });
    } else {
        // $(this).removeClass("is-open");
        $(this).addClass("is-open");
        $($(this).next(".collapsible-content")[0]).addClass("is-open")
        $($(this).next(".collapsible-content")[0]).css({ "height": "auto" });
    }
    // $(this).toggleClass("is-open");
    // let types = $(this).hasClass("is-open");
});
// $("button.collapsible-btn").click();
// $($("#indx_box1 .collapsibles-wrapper button.collapsible-btn")[0]).click();
$($(".water_full_main_box #indx_box1 .collapsibles-wrapper button.collapsible-btn")[0]).click();